import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { SharedProgressiveFormSitecoreModule } from '@innogy/shared/progressive-form/sitecore';

import { GenericEffects } from './store/+state/generic/generic.effects';

@NgModule({
  imports: [
    SharedProgressiveFormSitecoreModule,
    EffectsModule.forFeature([GenericEffects]),
  ],
})
export class FehSharedBootstrapModule {}
